import { finish, error } from '../../../modules/user/actions/change-contact-number';

import api from '../../../api';

export function request(dispatch, action) {
    api.post('/user/change-contact-number', {
        mobilePhone: action.mobilePhone
    }).then(
        ({ data }) => dispatch(finish(data)),
        ({ errors }) => dispatch(error(errors))
    );
}
